import React, { useEffect } from "react";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// hooks
import useIsAdmin from "frontend/hooks/useIsAdmin";

// components
import AuthMenu from "./AuthMenu";

// data
import { getAuthAdminMenu } from "data/links";
export const ADMIN_TEST_ID = "admin-menu-links";

// component
export const AdminMenu = () => {
    const { setAuthMenuHasThreeColumns } = useSiteHeader();
    const { isAdmin } = useIsAdmin();

    useEffect(() => {
        setAuthMenuHasThreeColumns(isAdmin);
    }, [isAdmin]);

    if (!isAdmin) return null;

    return <AuthMenu id={ADMIN_TEST_ID} menu={getAuthAdminMenu()} />;
};

export default AdminMenu;
